var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticStyle:{"padding":"0 20px 20px 20px !important"},attrs:{"width":"800px","title":_vm.title,"visible":_vm.visible,"before-close":_vm.handleClose,"top":"5vh"},on:{"update:visible":function($event){_vm.visible=$event}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }